import React from 'react';
import './../App.css';

const Navbar = () => {
  return (
    <div className="navbar">
      <a className="logo" href="/">
        <img src="/yrcgi_logo.png" alt="YRCGI logo" />
      </a>
      <div className="container">
        <h1>Yellow Ray Consulting Group Inc.</h1>
        <nav>
          <ul className="nav-menu">
            <li className="nav-links">
              <a href="https://www.yrcgi.com/" target="_blank" rel="noopener noreferrer">Yellow Ray Consulting Website</a>
            </li>
            <li className="nav-links">
              <a href="https://www.yellowray.solutions" target="_blank" rel="noopener noreferrer">Yellow Ray Education Website</a>
            </li>
            <li className="nav-links">
              <a href="https://www.yellowray.dev" target="_blank" rel="noopener noreferrer">Yellow Ray Development Portal</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;